import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Request a Quote',
  desc: 'Fill out our detailed form or text us on WhatsApp with your property details.'
}, {
  num: '02',
  title: 'We Schedule',
  desc: 'We provide a transparent price and lock in a date and time that works for you.'
}, {
  num: '03',
  title: 'We Reset Your Space',
  desc: 'Our vetted crew arrives on time and executes an architectural-grade deep clean.'
}, {
  num: '04',
  title: 'You Relax',
  desc: 'Walk into a pristine, drama-free environment that feels brand new.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-32 bg-graphite relative" data-id="element-111">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-112">
        <div className="mb-24 text-center" data-id="element-113">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-114">
            <div className="w-8 h-[1px] bg-lime" data-id="element-115"></div>
            <span className="text-paper/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-116">
              The Process
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-117"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-paper font-light" data-id="element-118">
            How It <span className="font-medium" data-id="element-119">Works.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 relative" data-id="element-120">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-8 left-0 w-full h-[1px] bg-concrete/10 z-0" data-id="element-121"></div>

          {steps.map((step, index) => <motion.div key={step.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="relative z-10" data-id="element-122">
              <div className="w-16 h-16 bg-ink flex items-center justify-center mb-8 border border-concrete/10" data-id="element-123">
                <span className="font-display text-xl text-lime font-light" data-id="element-124">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl text-paper font-medium mb-4 tracking-wide" data-id="element-125">
                {step.title}
              </h3>
              <p className="text-concrete/60 font-light text-sm leading-relaxed" data-id="element-126">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}